<form [formGroup]="invoiceLineForm">
<div style="margin-left:100px;margin-top:200px;">

    <mat-form-field appearance="fill" style="width:300px;color:gray">
    <mat-label>Revenue Type</mat-label>
    <mat-select formControlName="revenueCode" (selectionChange)="onCalculateRateData()">
        <mat-option value="">Select Revenue Type</mat-option>
        @for (revenueType of filteredRevenueTypes; track revenueType.code) {
            <mat-option [value]="revenueType.code" >
                {{revenueType.description}}
            </mat-option>
        }
    </mat-select>
        <mat-error *ngIf="invoiceLineForm.get('revenueCode')!.hasError('required')">The Reveue Type is required</mat-error>
    </mat-form-field>

</div>



<div style="margin-left:100px;margin-top:100px;">
    @if(activeTaxListForLot.length > 0){
        <div style="margin-left:0px;margin-top:10px;">
            <mat-checkbox formControlName="isTaxable" [disabled]="taxIsNotApplicable" (click)="onEvalTaxApplied()">{{checkboxText}}</mat-checkbox>
        </div>
            }
    @else {
        --
    }
</div>
</form>

<div style="margin-left:100px;margin-top:20px;">
    @if(selectedRevenueData){
        Exempt: {{selectedRevenueData.isExempt}} <br />
         <!-- @if(selectedRevenueData.isExempt){
            Disable Checkbox
        }
                @else {
            Enable Checkbox
        } -->
        <br />
         <br />
        <br />

        Enforce: {{selectedRevenueData.isEnforceable}} <br />
        <!-- @if(selectedRevenueData.isEnforceable){
            Cannot remove tax
        }
        @else {
            Can remove tax
        } -->
        <br />
        <br />
        <br />
        
        No Tax: {{selectedRevenueData.isFinal}} <br />
         <!-- @if(selectedRevenueData.isFinal){
            No Tax - gray out checkbox
        }
        @else {
            Is Tax
        } -->
    }   
</div>

<!-- <div style="margin-left:100px;margin-top:20px;">
    <div>taxIsNotApplicable: {{taxIsNotApplicable}}</div>
</div>

<div style="margin-left:100px;margin-top:20px;">
    <div>Select Rev Type Data: {{selectedRevenueData | json}}</div>
</div>

<div style="margin-left:100px;margin-top:20px;">
    <div>Revenue Code List {{filteredRevenueTypes | json}}</div>
</div> -->
